<div class="kt-toolbar-container" *ngIf="totalSelectedItems > 0" [class.kt-toolbar-container--vertical]="isVertical">
    <div class="kt-toolbar d-flex align-items-center" [class.flex-column]="isVertical">
        <!-- Selection Tracker -->
        <div class="selection-tracker d-flex align-items-center" [class.flex-column]="isVertical">
            <span class="selection-text">{{ totalSelectedItems }} {{ itemLabel }} selected</span>
            <mat-icon
                class="close-icon cursor-pointer"
                [class.ml-3]="!isVertical"
                (click)="onClearSelection()">close</mat-icon>
        </div>

        <div class="divider" [class.divider--horizontal]="isVertical"></div>

        <!-- Projected Actions Space -->
        <div class="actions-container d-flex flex-grow-1" [class.flex-column]="isVertical" [class.align-items-center]="!isVertical">
            <ng-content></ng-content>
        </div>
    </div>
</div>
